/* eslint-disable no-unused-vars */
export const RE_DIGIT = new RegExp(/^\d+$/);
